import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReplyTable from '../component/Admin/ReplyTable';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import Footer from '../component/Footer';

const Admin = () => {
    const [accountId, setId] = useState('');
    const [password, setPassword] = useState('');
    const [isLogin, setIsLogin] = useState(false);
    const [replyData, setReplyData] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [searchConditions, setSearchConditions] = useState({
        willAttend: { value: 'A', label: '전체' },
        willHaveMeal: { value: 'A', label: '전체' },
        weddingPartyRole: { value: 'ALL', label: '전체' }
    });
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const attendOptions = [
        { value: 'A', label: '전체' },
        { value: 'Y', label: '참석' },
        { value: 'N', label: '미참석' }
    ];

    const mealOptions = [
        { value: 'A', label: '전체' },
        { value: 'Y', label: '식사O' },
        { value: 'N', label: '식사X' }
    ];

    const partyRoleOptions = [
        { value: 'ALL', label: '전체' },
        { value: 'GROOM', label: '신랑측' },
        { value: 'BRIDE', label: '신부측' }
    ];

    const customStyles = {
        control: (base) => ({
            ...base,
            minWidth: '80px',
            fontSize: '13px',
            border: '1px solid #c8c8c8',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #c8c8c8'
            }
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '13px',
            backgroundColor: state.isSelected ? '#f0f0f0' : 'white',
            color: 'black',
            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999
        }),
        placeholder: (base) => ({
            ...base,
            color: '#666',
            fontSize: '10px'
        })
    };

    useEffect(() => {
        const adminLoginStatus = sessionStorage.getItem(`${mainPage}_adminLogin`);
        if (adminLoginStatus === 'true') {
            setIsLogin(true);
            fetchReplyData(0, true);
        }
    }, []);

    const handleSearchConditionChange = (selectedOption, { name }) => {
        setSearchConditions(prev => ({
            ...prev,
            [name]: selectedOption
        }));
    };

    const handleSearch = () => {
        setPage(0);
        setReplyData(null);
        fetchReplyData(0, true);
    };

    const fetchReplyData = async (pageNumber, isNewSearch = false) => {
        if (isLoading || (!hasMore && !isNewSearch)) return;

        setIsLoading(true);
        const searchRequestBody = {
            url: mainPage,
            willAttend: searchConditions.willAttend.value,
            willHaveMeal: searchConditions.willHaveMeal.value,
            weddingPartyRole: searchConditions.weddingPartyRole.value
        };

        try {
            const replyResponse = await axios.post(
                `${process.env.REACT_APP_API_URL}/_api/v1/reply/search?page=${pageNumber}&size=10`,
                searchRequestBody,
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (replyResponse.status === 200) {
                const newData = replyResponse.data;
                setHasMore(!newData.data.last);
                
                if (isNewSearch) {
                    setReplyData(newData);
                } else {
                    setReplyData(prev => ({
                        ...prev,
                        data: {
                            ...prev.data,
                            content: [...prev.data.content, ...newData.data.content]
                        }
                    }));
                }
                setPage(pageNumber);
            }
        } catch (error) {
            console.error('데이터 조회 에러:', error.response?.data || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLoadMore = () => {
        if (!isLoading && hasMore) {
            fetchReplyData(page + 1);
        }
    };

    const handleLogin = async () => {
        const requestBody = {
            accountId,
            password,
        };

        try {
            const response = await axios.post(`${API_URL}/_api/v1/auth/admin/login`, requestBody, {
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.status === 200) {
                setIsLogin(true);
                // 로그인 성공 시 세션 스토리지에 로그인 상태 저장
                sessionStorage.setItem(`${mainPage}_adminLogin`, 'true');
                fetchReplyData(0, true);
            }
        } catch (error) {
            alert('로그인 실패 😭. 다시 시도해주세요.');
            console.error('에러 발생:', error.response?.data || error.message);
        }
    };

    const handleLogout = () => {
        setIsLogin(false);
        sessionStorage.removeItem(`${mainPage}_adminLogin`);
    };

    return (
        <div style={{ 
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '20px',
            position: 'relative'
        }}>
            {!isLogin ? (
                // Show login form when not logged in
                <div style={{ width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 'auto 0' }}>
                    <h3 style={{fontSize: '20px', fontWeight: 'bold', marginBottom: '20px'}}>
                        참석여부 확인하기
                    </h3>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '180px'}}>
                        <span style={{ margin: '10px 0' }}>
                            <p>ID</p>
                            <input
                            type="text"
                            placeholder="아이디"
                            value={accountId}
                            onChange={(e) => setId(e.target.value)}
                            style={{ border: '1px #c8c8c8 solid', borderRadius: '10px', padding: '2px 6px' }}
                            />
                        </span>

                        <span>
                            <p>Password</p>
                            <input
                                type="password"
                                placeholder="비밀번호"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{ border: '1px solid #c8c8c8', borderRadius: '10px', padding: '2px 6px' }}
                            />
                        </span>
                    </div>

                    <button
                        className="spring_btn"
                        style={{ width: '95px', margin: '30px auto', color: '#313131'}}
                        onClick={handleLogin}
                    >
                        로그인
                    </button>
                </div>
            ) : (
                <div style={{ width: '95%', maxWidth: '500px' }}>
                    <div style={{ 
                        display: 'flex', 
                        gap: '7px', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '10px 10px'
                    }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ fontSize: '10px', color: '#666', marginBottom: '2px' }}>참석여부</span>
                            <Select
                                name="willAttend"
                                value={searchConditions.willAttend}
                                onChange={(option) => handleSearchConditionChange(option, { name: 'willAttend' })}
                                options={attendOptions}
                                styles={customStyles}
                                placeholder="참석"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ fontSize: '10px', color: '#666', marginBottom: '2px' }}>식사여부</span>
                            <Select
                                name="willHaveMeal"
                                value={searchConditions.willHaveMeal}
                                onChange={(option) => handleSearchConditionChange(option, { name: 'willHaveMeal' })}
                                options={mealOptions}
                                styles={customStyles}
                                placeholder="식사"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ fontSize: '10px', color: '#666', marginBottom: '2px' }}>참석측</span>
                            <Select
                                name="weddingPartyRole"
                                value={searchConditions.weddingPartyRole}
                                onChange={(option) => handleSearchConditionChange(option, { name: 'weddingPartyRole' })}
                                options={partyRoleOptions}
                                styles={customStyles}
                                placeholder="참석측"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        </div>

                        <button 
                            onClick={handleSearch}
                            className="spring_btn"
                            style={{ 
                                fontSize: '14px',
                                width: '50px',
                                marginTop: '22px',
                                color: '#313131',
                                fontFamily: 'sans-serif'
                            }}
                        >
                            검색
                        </button>
                    </div>

                    {replyData ? (
                        <>
                        <div>
                            <p style={{width: '100%', textAlign: 'center', margin: '20px 0'}}>선택하신 인원은 총 <span style={{fontWeight: 'bold'}}>{replyData.data.totalElements}</span> 명입니다</p>
                        </div>
                        <div>
                            <ReplyTable 
                                replyData={replyData}
                                onLoadMore={handleLoadMore}
                                hasMore={hasMore}
                                isLoading={isLoading}
                            />
                        </div>
                        </>
                    ) : (
                        <p>답변을 가져오는 중...</p>
                    )}

                    <div style={{
                        // position: 'sticky',
                        bottom: '20px',
                        // left: '50%',
                        // transform: 'translateX(-50%)',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>
                        <button 
                            className="spring_btn" 
                            onClick={handleLogout} 
                            style={{ 
                                width: '95px',
                                margin: '5px',
                                padding: '5px',
                                borderRadius: '5px',
                                color: '#313131',
                                fontFamily: 'sans-serif'
                            }}
                        >
                            로그아웃
                        </button>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default Admin;
